<template>
    <div>
        <verifyUser v-if="register_state == 'verifyUser'"
            :modalController="modalController"
            @submitVerify="submitVerify($event)">
        </verifyUser>

        <verifyOtp v-if="register_state == 'verifyOTP'"
            :modalController="modalController"
            :dataVerify="dataVerify"
            @callApiVerifyMember="callApiVerifyMember($event)">
        </verifyOtp>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import CacheHelper from '@/helper/CacheHelper';
//component
import verifyUser from "./components/verifyUser.vue";
import verifyOtp from "./components/verifyOtp.vue";
//mixin
import ModalMixin from '@/mixin/ModalMixin';
//service
import BzbsRegister from "../service/BzbsRegister.js"

export default {
    name: 'verifypage',
    mixins: [ModalMixin],
    components: {
        verifyUser,
        verifyOtp,
    },
    data: function() {
        return {
            register_state: "verifyUser",// verifyUser, verifyOTP
            data_verify: {},
        }
    },
    methods: {
        // ModalMixin
        onSetupModalCompleted: function() {
            this.initialOtpModal();
        },

        submitVerify: function (data) {
            this.modalController.loadingModal.hide();
            this.dataVerify = data;
            this.register_state = "verifyOTP";
        },
        callApiVerifyMember: function (data) {
            this.loadingModal.show();
            return new Promise((resolve) => {
                BzbsRegister.verifyMember(data.idCard, data.mobile)
                    .subscribe({
                        next: (res) => {
                            console.log('verify member', res.data);

                            if (res.data.length > 0) {
                                this.setCacheFillForm(res.data[0]);
                            }
                            this.$router.push('register');

                            this.modalController.loadingModal.hide();
                            resolve(res);
                        },
                        error: (err) => {
                            console.log(err);
                            const msg = err.message
                            this.modalController.loadingModal.hide();
                            this.modalController.alertModal.clearModal()
                                .setMsg(msg)
                                .show();
                            resolve(null);
                        }
                });
            });
        },
        setCacheFillForm: function(data) {
            let cache = new CacheHelper('session');
            cache.setCache('fill_form_register', data);
        },

    }
}
</script>
